interface AddressFields {
  street?: string | null;
  houseNumber?: string | null;
  postalCode?: string | null;
  city?: string | null;
  country?: string | null;
}

export function formatAddress(r: AddressFields): string {
  const num = r.houseNumber?.trim();
  const streetBase = r.street?.trim() || '';
  const streetPart = num && streetBase && !streetBase.endsWith(num)
    ? `${streetBase} ${num}`
    : streetBase || num;
  return [streetPart, r.postalCode, r.city, r.country].filter(Boolean).join(', ');
}

export function formatAddressShort(r: AddressFields): string {
  const num = r.houseNumber?.trim();
  const streetBase = r.street?.trim() || '';
  const streetPart = num && streetBase && !streetBase.endsWith(num)
    ? `${streetBase} ${num}`
    : streetBase || num;
  return [streetPart, r.postalCode, r.city].filter(Boolean).join(', ');
}
